'use client'

import { useState } from 'react'

import { AlertTriangle, Trash2 } from 'lucide-react'

import { Button } from '@/shared/ui/Button'
import { Card, CardBody } from '@/shared/ui/Card'
import { inputClassName } from '@/shared/ui/input-styles'

import { useAccountDeletion } from '../hooks/useAccountDeletion'

export function DeleteAccountSection() {
  const { requestDeletion, isLoading, done, fieldError } = useAccountDeletion()
  const [confirming, setConfirming] = useState(false)
  const [password, setPassword] = useState('')

  if (done) {
    return (
      <Card variant="default">
        <CardBody className="flex flex-col gap-2">
          <p className="font-semibold text-foreground">Exclusão solicitada.</p>
          <p className="text-sm text-muted-foreground">
            Sua conta foi desativada. Você tem 30 dias para reativá-la: basta
            fazer login novamente antes do fim do prazo. Depois disso, seus
            dados pessoais serão anonimizados de forma definitiva.
          </p>
        </CardBody>
      </Card>
    )
  }

  return (
    <div className="rounded-2xl border border-destructive/30 bg-destructive/5 p-5">
      <div className="flex items-start gap-3">
        <span className="mt-0.5 flex size-9 shrink-0 items-center justify-center rounded-full bg-destructive/10 text-destructive">
          <AlertTriangle className="size-5" aria-hidden />
        </span>
        <div className="flex-1">
          <h3 className="text-sm font-semibold text-destructive">
            Excluir minha conta
          </h3>
          <p className="mt-1 text-sm text-muted-foreground">
            Sua conta é desativada imediatamente e você perde acesso a pontos,
            medalhas e histórico. Há uma carência de 30 dias para reativar
            (fazendo login); depois disso a exclusão é definitiva e
            irreversível.
          </p>

          {!confirming ? (
            <Button
              variant="destructive"
              size="sm"
              className="mt-4"
              onClick={() => setConfirming(true)}
            >
              <Trash2 className="size-4" />
              Excluir minha conta
            </Button>
          ) : (
            <form
              className="mt-4 flex flex-col gap-3"
              onSubmit={event => {
                event.preventDefault()
                requestDeletion(password)
              }}
            >
              <div className="flex flex-col gap-1">
                <label className="text-xs font-medium text-muted-foreground">
                  Confirme sua senha
                </label>
                <input
                  type="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={event => setPassword(event.target.value)}
                  className={inputClassName}
                />
                {fieldError && (
                  <span className="text-xs text-destructive">{fieldError}</span>
                )}
              </div>
              <div className="flex gap-2">
                <Button
                  type="submit"
                  variant="destructive"
                  size="sm"
                  disabled={isLoading || password.length === 0}
                  loading={isLoading}
                >
                  {isLoading ? 'Processando...' : 'Confirmar exclusão'}
                </Button>
                <Button
                  type="button"
                  variant="secondary"
                  size="sm"
                  onClick={() => {
                    setConfirming(false)
                    setPassword('')
                  }}
                >
                  Cancelar
                </Button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  )
}
